import { Box } from '@mui/material';
import List from 'components/list/list';
import ListCell from 'components/list/list-cell';
import ListRow from 'components/list/list-row';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { TemperatureProfileInformation } from 'views/bluviu-nutrition/features/calibrations/types/temperature-profile-information.type';

type Props = {
  temperatureProfile: TemperatureProfileInformation[];
};

const ViewTemperatureTable: React.FC<Props> = ({ temperatureProfile }) => {
  return (
    <Box display={'flex'} maxHeight={800} flexDirection={'column'} gap={4}>
      <List
        dark
        options={[
          {
            id: 'weekNumber',
            label: 'Week Number',
            align: 'center',
          },
          {
            id: 'averageTemperature',
            label: 'Average Temperature',
            align: 'center',
          },
        ]}>
        {temperatureProfile.map((profile, idx) => (
          <ListRow key={idx}>
            <ListCell
              align="center"
              sx={{
                fontSize: '16px',
              }}>
              {profile.weekNumber}
            </ListCell>
            <ListCell
              align="center"
              sx={{
                fontSize: '16px',
              }}>
              <FormattedNumber style={'decimal'} value={profile.averageTemperature} maximumFractionDigits={2} />°
            </ListCell>
          </ListRow>
        ))}
      </List>
    </Box>
  );
};

export default React.memo(ViewTemperatureTable);
